import React, { useEffect, useState } from "react";
import { seleccionarOperadores } from "../../Services/asesores.services";
import { FiChevronDown } from "react-icons/fi";

const Operador = ({ value, onChange, disabled, operadores: operadoresProp }) => {
  const [operadores, setOperadores] = useState(Array.isArray(operadoresProp) ? operadoresProp : []);
  const [loading, setLoading] = useState(!Array.isArray(operadoresProp));
  const [error, setError] = useState(false);

  useEffect(() => {
    if (Array.isArray(operadoresProp)) {
      setOperadores(operadoresProp);
      setLoading(false);
      setError(false);
      return;
    }
    
    const cargarOperadores = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await seleccionarOperadores();

        // Soporta ambos formatos
        const data = response?.data?.data || response?.data || response?.data?.data;

        if (Array.isArray(data) && data.length > 0) {
          setOperadores(data);
        } else if (response?.data?.success) {
          setOperadores(response.data.data);
        } else {
          setError(true);
        }

      } catch (err) {
        console.error("Error cargando operadores:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    cargarOperadores();
  }, [operadoresProp]);

  return (
    <div style={{ position: 'relative' }}>
      <select
        name="operadorId"
        className="form-control"
        value={value}
        onChange={onChange}
        disabled={disabled || loading || error}
        required
        style={{ appearance: 'none', paddingRight: '2rem' }}
      >
        {loading && <option value="">Cargando operadores...</option>}

        {!loading && error && (
          <option value="">Error cargando operadores</option>
        )}

        {!loading && !error && (
          <>
            <option value="">Operador</option>
            {operadores.map(op => (
              <option key={op.operadorId} value={op.operadorId}>
                {op.descripcion}
              </option>
            ))}
          </>
        )}
      </select>
      <FiChevronDown
        style={{
          position: 'absolute',
          right: '0',
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          color: '#8f1a95',
        }}
      />
    </div>
  );
};

export default Operador;
